// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc, DisplayNamedFragmentDoc } from '../../../fragments/commonFragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ChangeEventEstimatesTabQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type ChangeEventEstimatesTabQuery = { __typename?: 'Query', changeEvent: { __typename?: 'ChangeEvent', id: string, estimates: Array<{ __typename?: 'Estimate', totalCostInCents: number, totalPriceInCents: number, updatedAt: Types.Scalars['DateTime']['input'], id: string, name: string, blueprintUrl: { __typename?: 'Url', path: string }, type: { __typename?: 'EstimateTypeDetail', name: string, code: Types.EstimateType }, status: { __typename?: 'EstimateStatusDetail', code: Types.EstimateStatus, name: string } }> } };


export const ChangeEventEstimatesTabDocument = gql`
    query ChangeEventEstimatesTab($id: ID!) {
  changeEvent(id: $id) {
    id
    estimates {
      ...Named
      blueprintUrl {
        path
      }
      type {
        name
        code
      }
      totalCostInCents
      totalPriceInCents
      updatedAt
      status {
        code
        name
      }
    }
  }
}
    ${NamedFragmentDoc}`;

/**
 * __useChangeEventEstimatesTabQuery__
 *
 * To run a query within a React component, call `useChangeEventEstimatesTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useChangeEventEstimatesTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChangeEventEstimatesTabQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useChangeEventEstimatesTabQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ChangeEventEstimatesTabQuery, ChangeEventEstimatesTabQueryVariables> & ({ variables: ChangeEventEstimatesTabQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ChangeEventEstimatesTabQuery, ChangeEventEstimatesTabQueryVariables>(ChangeEventEstimatesTabDocument, options);
      }
export function useChangeEventEstimatesTabLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ChangeEventEstimatesTabQuery, ChangeEventEstimatesTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ChangeEventEstimatesTabQuery, ChangeEventEstimatesTabQueryVariables>(ChangeEventEstimatesTabDocument, options);
        }
export function useChangeEventEstimatesTabSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ChangeEventEstimatesTabQuery, ChangeEventEstimatesTabQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ChangeEventEstimatesTabQuery, ChangeEventEstimatesTabQueryVariables>(ChangeEventEstimatesTabDocument, options);
        }
export type ChangeEventEstimatesTabQueryHookResult = ReturnType<typeof useChangeEventEstimatesTabQuery>;
export type ChangeEventEstimatesTabLazyQueryHookResult = ReturnType<typeof useChangeEventEstimatesTabLazyQuery>;
export type ChangeEventEstimatesTabSuspenseQueryHookResult = ReturnType<typeof useChangeEventEstimatesTabSuspenseQuery>;
export type ChangeEventEstimatesTabQueryResult = Apollo.QueryResult<ChangeEventEstimatesTabQuery, ChangeEventEstimatesTabQueryVariables>;